import { render, staticRenderFns } from "./SustainabilityImpact.vue?vue&type=template&id=302c51b2&scoped=true&"
import script from "./SustainabilityImpact.vue?vue&type=script&lang=ts&"
export * from "./SustainabilityImpact.vue?vue&type=script&lang=ts&"
import style0 from "./SustainabilityImpact.vue?vue&type=style&index=0&id=302c51b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302c51b2",
  null
  
)

export default component.exports